module.exports = __webpack_public_path__ + "img/scatter_logo_lines.e42ecbc6.svg";